<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4 fw-bold" style="color: #b03a45;">➕ Add New Income</h4>

      <form @submit.prevent="handleSubmit">
        <div class="row">
          <!-- Type -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label text-secondary">Type *</label>
              <select v-model="form.type" class="form-select border-0" required>
                <option disabled value="">Select type</option>
                <option value="cash">Cash</option>
                <option value="gift">Gift</option>
                <option value="transfer">Transfer</option>
              </select>
            </div>
          </div>

          <!-- Amount -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label text-secondary">Amount *</label>
              <input type="number" class="form-control border-0" v-model="form.amount" step="0.01" required />
            </div>
          </div>

          <!-- Date -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label text-secondary">Date *</label>
              <input type="date" class="form-control border-0" v-model="form.date" required />
            </div>
          </div>

          <!-- Note -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label text-secondary">Note</label>
              <input type="text" class="form-control border-0" v-model="form.note" />
            </div>
          </div>

          <!-- User (CEO) -->
          <div class="col-md-6 mb-3">
            <div class="bg-white p-3 rounded shadow-sm">
              <label class="form-label text-secondary">CEO *</label>
              <select v-model="form.user_id" class="form-select border-0" required>
                <option disabled value="">Select CEO</option>
                <option v-for="user in ceoUsers" :key="user.id" :value="user.id">
                  {{ user.firstname }} {{ user.lastname }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="text-end mt-4">
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            Save Income
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import axios from '@/api'

const router = useRouter()
const toast = useToast()

const form = ref({
  type: '',
  amount: '',
  date: '',
  note: '',
  user_id: ''
})

const ceoUsers = ref([])

const fetchCeoUsers = async () => {
  try {
    const res = await axios.get('/Financial/incomes/ceo-users')
    ceoUsers.value = res.data.data || []
  } catch (e) {
    toast.error('Failed to load CEO users')
  }
}

const handleSubmit = async () => {
  try {
    await axios.post('/Financial/incomes', form.value)
    toast.success('Income created successfully!')
    router.push('/office-expenses')
  } catch (e) {
    console.error(e)
    toast.error(e.response?.data?.message || 'Error creating income')
  }
}

onMounted(fetchCeoUsers)
</script>

<style scoped>
.form-label {
  font-weight: bold;
  color: #b03a45;
}
</style>
